import React from "react";
import { NavLink } from "react-router-dom";

/** Tabs across the Mobstr staff screens ("Admin Functions"). */
export default function AdminTabs({ userLoggedIn }) {
  const tabs = [
    { to: "/usersreport", label: "Users report" },
    ...(userLoggedIn?.isSuperUser ? [{ to: "/admin/news", label: "News" }] : []),
  ];
  return (
    <nav className="mb-6 flex gap-1 border-b border-gray-200" aria-label="Admin sections">
      {tabs.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          className={({ isActive }) =>
            `-mb-px border-b-2 px-4 py-2 text-sm font-medium ${
              isActive ? "border-mobstr-purple text-gray-900" : "border-transparent text-gray-500 hover:text-gray-800"
            }`
          }
        >
          {t.label}
        </NavLink>
      ))}
    </nav>
  );
}
